/**
 * 版本的封装
 * @author huangyiustb
 * @email huangyiustb@didichuxing.com
 */

import {
  each,
  UA,
  isIOS,
  isAndroid,
  iosVersion,
  androidVersion
} from '../util'

const appRE = /didi\.(\w+)[\s\/]([\d\.]+)/,
      androidAppREG = /didigsui.*_(.+)_\d+$/ig,
      iOSAppREG = /ddudriver.*_(.+)$/ig,
      daijiaAppREG = /(daijia\.\w+)[\s\/]([\d\.]+)/ig,
      financeAppREG = /(finance\.\w+)[\s\/]([\d\.]+)/ig
const UNKNOWN = 'unknown';


// 判断是否是 主端 顺风车容器
const inBeatles = (ua) => {
  return /didi\.passenger.+beatles/i.test(ua);
};

// 判断是否是 顺丰独立端 容器
const inBlord = (ua) => {
  return /didi\.passenger.+beatles\sblord/i.test(ua);
};

export let app = {};

export function initApp(DDBridge) {
  let matches = UA.match(appRE) || daijiaAppREG.exec(UA) || financeAppREG.exec(UA),
      otherMatches = androidAppREG.exec(UA) || iOSAppREG.exec(UA)
  let env = UNKNOWN
  let version = UNKNOWN
  if (matches) {
    env = matches[1]
    version = matches[2]
  } else if (otherMatches) {
    env = otherMatches[0]
    version = otherMatches[1]
  }

  // 主端 但是 是 顺风车的 web 容器
  if (inBlord(UA)) {
    // 独立端
    env = 'blord';
    version = matches[2];
    // version =
  } else if (inBeatles(UA)) {
    // 滴滴乘客端顺风车webview内
    env = 'beatles';
    version = matches[2];
  }

  let system = isIOS ? 'ios' : isAndroid ? 'android' : UNKNOWN
  let sysVersion = isIOS ? iosVersion : isAndroid ? androidVersion : UNKNOWN

  DDBridge.app = app = {
    env,
    version,
    system,
    sysVersion,
    driver: !!otherMatches
  }
}

export function inApp() {
  return app.env && app.env !== UNKNOWN
};

export function compareAppVersion(...args) {
  switch (args.length) {
    case 2:
      return compare(app.version, args[0], args[1])
    case 3:
      return compare.apply(null, args)
  }
}

export function compareSysVersion(...args) {
  switch (args.length) {
    case 2:
      return compare(app.sysVersion, args[0], args[1])
    case 3:
      return compare.apply(null, args)
  }
}

function compare(v1, symbol, v2) {
  v1 = parse(v1)
  v2 = parse(v2)
  if (symbol.indexOf('=') !== -1 && v1 === v2) {
    return true
  }
  if (symbol.indexOf('>') !== -1 && v1 > v2) {
    return true
  }
  if (symbol.indexOf('<') !== -1 && v1 < v2) {
    return true
  }
  return false
}

function parse(version = '') {
  version = version.split('.')
  version.length = 4

  let ret = []
  each(version, (n) => {
    n = n * 1
    if (n) {
      ret.push(n >= 10 ? n : '0' + n)
    } else {
      ret.push('00')
    }
  })
  return parseInt(ret.join(''), 10)
}



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridge/app.js